import { GENDER } from '../../domain/domainCodes.js'
/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const profileStrings = {
  title: 'User Profile Information',
  subtitle:
    'Use this page to keep your personal details up to date. Your name appears on the certificate exactly as you type it here, so make sure it reads the way you want it to.',
  save: 'Save',
  saved: 'Profile has been updated',
  close: 'Close',

  fields: {
    Username: 'Username',
    EnglishName: 'English Full name',
    ArabicName: 'Arabic Full name',
    Gender: 'Gender',
    Email: 'Email',
    Phone: 'Telephone',
    Mobile: 'Mobile',
    EmployeeId: 'Employee Id',
    DepartmentId: 'Group',
  },

  order: [
    'Username',
    'EnglishName',
    'ArabicName',
    'Gender',
    'Email',
    'Phone',
    'Mobile',
    'EmployeeId',
    'DepartmentId',
    'Attribute1',
    'Attribute2',
    'Attribute3',
    'Attribute4',
    'Attribute5',
  ],

  required: ['Username', 'EnglishName', 'ArabicName', 'Email'],

  genders: [
    { value: String(GENDER.MALE), label: 'Male' },
    { value: String(GENDER.FEMALE), label: 'Female' },
  ],

  validation: {
    ArabicName:
      'The Arabic name must be between 2 and 100 characters and contain Arabic letters only',
    EnglishName:
      'The English name must be between 2 and 100 characters and contain English letters only',
    Email: 'The email address is not valid',
    Phone: 'The phone number must be between 4 and 100 digits and accepts numbers only',
    Mobile: 'The mobile number must be between 4 and 10 digits and accepts numbers only',
    requiredEnglishName: 'The full English name is required',
    requiredArabicName: 'The full Arabic name is required',
    requiredEmail: 'E-mail is required.',
  },
}

export const systemPageStrings = {
  error: {
    title: 'System Error',

    message: 'Something went wrong!\\nPlease try again later.',
    sorry: 'Sorry!',
    home: 'Home',
    contact: 'Contact Us',
  },

  unauthorized: {
    title: 'Unauthorized!',
    message: 'you are not authorized to view this page',
    home: 'Home',
  },

  shutdown: {
    title: 'UnExcpected Error',
    heading: 'System has been shutdown',
    message: 'For ferther details, please refer to the system administrator',

    managerNote: 'We are sorry for this inappropriate action, Click to be redirect to license update page',
    licenseLink: 'license update',
    logout: 'Logout',
  },

  redirect: {
    title: 'Update your profile',
    message: 'You will be redirected to the profile page to update necessary entries',
    go: 'Continue now',
  },
}
